import React, { Component } from 'react';
import { View, Platform } from 'react-native';

import { ViewPropTypes } from 'deprecated-react-native-prop-types';
import { isFunction as _isFunction } from 'lodash';
import PropTypes from 'prop-types';

import { VFInput } from '@vfgroup-oneplatform/foundation/Components';
import { withTheme } from '@vfgroup-oneplatform/foundation/Components/Themes';

import styles from './SearchBar.Styles';

class SearchBar extends Component {
  onChangeText = text => {
    const { onChangeText } = this.props;
    _isFunction(onChangeText) && onChangeText(text);
  };

  render() {
    const { containerStyle, theme, isLoading } = this.props;
    return (
      <View style={containerStyle}>
        <VFInput
          onChangeText={this.onChangeText}
          ref={ref => {
            this.input = ref;
          }}
          fontSize={18}
          textInputContainerStyle={styles.textInputContainerStyle}
          contentInset={{ label: Platform.OS == 'android' ? 1 : -1 }}
          label={'top_up_someone_else_contact_list_search_bar_placholder'}
          baseColor={theme.colors.textInput.default.baseColor}
          tintColor={theme.colors.textInput.default.tintColor}
          selectionColor={theme.colors.textInput.default.selectionColor}
          textColor={theme.colors.textColor}
          containerStyle={[styles.inputContainer]}
          disabled={isLoading}
        />
      </View>
    );
  }
}

SearchBar.defaultProps = {
  onChangeText: () => null,
};
SearchBar.propTypes = {
  containerStyle: ViewPropTypes.style,
  onChangeText: PropTypes.func,
  isLoading: PropTypes.bool,
  theme: PropTypes.shape({
    name: PropTypes.string,
    isDark: PropTypes.bool,
    colors: PropTypes.object,
  }),
};

export default withTheme(SearchBar);
